/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TierLimits, TierLimits$inboundSchema } from "./tierlimits.js";

export type UsageTiers = {
  enterprise: TierLimits;
  free: TierLimits;
  payg: TierLimits;
  pro: TierLimits;
};

/** @internal */
export const UsageTiers$inboundSchema: z.ZodMiniType<UsageTiers, unknown> = z
  .object({
    enterprise: TierLimits$inboundSchema,
    free: TierLimits$inboundSchema,
    payg: TierLimits$inboundSchema,
    pro: TierLimits$inboundSchema,
  });

export function usageTiersFromJSON(
  jsonString: string,
): SafeParseResult<UsageTiers, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UsageTiers$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UsageTiers' from JSON`,
  );
}
